import Vue from "vue";
import _ from "lodash";
import qs from "qs";
import moment from "moment";

const URL = "/db/user";
const API_URL = URL + "/api/";

const state = {
  user: [],
  role: [],
  user_loaded: false
};

const getters = {
  userInjected(state) {
    return _.cloneDeep(state.user).map(data => {
      data.total_training = data.training.length;
      return data;
    });
  },
  userByPeriode(state, getters, rootState) {
    let user = _.cloneDeep(
      state.user.filter(u => {
        return u.id_user != rootState.auth.profil.id_user;
      })
    );
    return user.map(data => {
      data.training = data.training.filter(tr => {
        let bool = true;
        if (moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = data.training.length;
      return data;
    });
  }
};

const mutations = {
  LOADED(state, payload) {
    state.user_loaded = payload;
  },
  SET_ROLE(state, payload) {
    state.role = payload;
  },
  SET_USER(state, payload) {
    state.user = payload;
  },
  ADD_USER(state, payload) {
    state.user.push(payload);
  },
  UPDATE_USER(state, payload) {
    state.user = _.unionBy([payload], state.user, "id_user");
  },
  DELETE_USER(state, ids) {
    _.remove(state.user, function(user) {
      return ids.includes(user.id_user);
    });
    state.user = [...state.user];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("SET_ROLE", res.data.role);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_USER({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("LOADED", true);
      commit("SET_USER", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_USER({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_USER", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  UPDATE_USER({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_user, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_USER", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_USER({ commit }, payload) {
    let ids = payload.map(p => p.id_user).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_USER", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
